<template>
  <div>
    <modal
      id="p-wallet-player-modal"
      class="p-wallet-player-modal-wrapper"
      size="800px"
      :show.sync="show"
      :footer="false"
    >
      <div class="p-wallet-player-modal-wrapper row w-100">
          <div class="row w-100 p-wallet-player-modal-items ">
                <div class="w-100 row p-wallet-player-modal-item  mb-3 align-items-center justify-content-center">
                    <h3 class="p-wallet-player-modal-title">نام سالن : </h3>
                    <h3 class="p-wallet-player-modal-title mr-2">empty </h3>
                </div>
                <div class="w-100 row p-wallet-player-modal-item  mb-3 align-items-center justify-content-center">
                    <h3 class="p-wallet-player-modal-title">استان : </h3>
                    <h3 class="p-wallet-player-modal-title mr-2">empty </h3>
                </div>
                <div class="w-100 row p-wallet-player-modal-item  mb-3 align-items-center justify-content-center">
                    <h3 class="p-wallet-player-modal-title">شهر :  </h3>
                    <h3 class="p-wallet-player-modal-title mr-2">empty </h3>
                </div>
                <div class="w-100 row p-wallet-player-modal-item  mb-3 align-items-center justify-content-center">
                    <h3 class="p-wallet-player-modal-title">تاریخ و ساعت سانس : </h3>
                    <div class="p-wallet-player-modal-title mr-2 ltr d-flex align-items-center">
                      <h3>1398/05/05</h3>
                      <h3 class="ml-2">11:05</h3>
                    </div>
                </div>
          </div>
      </div>

    </modal>
  </div>
</template>

<script>


export default {
    name: 'modalWalletPlayer',
    props: {
      active                  : { type: [Boolean, Number], default: false },
      singleValueModalPlayer  : { type: [Array, Object], default: {} },
    },

    data() {
      return {
      }
    },

    computed: {
      show: {
        set(val) {
          this.$emit('update:active', !!val)
        },
        get() {
          return !!this.active
        }
      },
    },

    mounted () {
    },

    watch: {

    },

    methods: {


    },

}
</script>
